import $ from 'jquery';
import fetch from '@/service/fetch';
import { apiDomain } from '@/service/fetch';
import { getStorage, removeStorage } from '../service/auth'
//请求数据的方法全部封装在这里



export function PostDataS (query) {
  query.device_source = 'tj'
  return fetch({
    method: 'post',
    data: query
  })
}
//--post请求
export function PostData (query) {
  query.device_source='tj'
  return fetch({
    method: 'post',
    data: query
  })
}
export function getData (query) {
  query.device_source='tj'
  return fetch({
    method: 'get',
    data: query
  })
}

//阻塞试调用，由于dhtmlx使用的回调方式，无法支持异步，引入jquery进行阻塞时post
export function blockPost (postdat, resolve , reject) {
  $.ajaxSettings.async = false;
  var ret = 0;
  $.ajax({
    type: 'POST',
    url: apiDomain,
    data: postdat,
    headers:{
        Authorization: getStorage('token')
    },
    success: function (data) {
        ret = JSON.parse(JSON.stringify(data));
    }
})
  // $.post(apiDomain, postdat,
  // function(data,status){
  //     ret = JSON.parse(JSON.stringify(data));
  // });
  $.ajaxSettings.async = true;
  return ret;
}

//--get请求
export function GetData (query) {
  return fetch({
    method: 'post',
    data: query
  })
}

export function PostDataBlob(query) {
  return fetch({
    method: 'post',
    responseType: 'arraybuffer',
    data: query,
  });
}


// WEBPACK FOOTER //
// ./src/api/fetchdata.js



// WEBPACK FOOTER //
// ./src/api/fetchdata.js